import React from "react";
import Nav from "@/components/site/Nav";
import Footer from "@/components/site/Footer";
import NewKindOfReader from "@/components/site/OurDifference";
import NZStory from "@/components/site/NZStory";
import BrandStripe from "@/components/site/BrandStripe";
import SectionHeader from "@/components/site/SectionHeader";
import { GoodTagline } from "@/components/site/GoodTagline";
import useSEO from "@/hooks/useSEO";

export default function About() {
  useSEO({
    title: "About",
    description: "The story behind Good Eyes — a New Zealand-designed range of reading glasses that blends fashion-forward design with recycled materials, colour-coded strengths and accessible pricing.",
    path: "/about",
  });
  return (
    <div className="min-h-screen bg-white text-[color:var(--ge-navy)]" data-testid="about-page">
      <Nav />
      <main>
        {/* Hero */}
        <section className="relative bg-white pt-40 pb-24 md:pt-48 md:pb-32">
          <div className="ge-container">
            <SectionHeader
              kicker="About"
              title={<>A design-led approach<br />to <span style={{ color: "var(--ge-red)" }}>reading glasses</span>.</>}
              subtitle="Good Eyes is a New Zealand-designed range of reading glasses, imagined for pharmacy retail. We blend fashion-forward design with sustainable materials, colour-coded strengths, and accessible pricing, for a reader shopping experience that feels genuinely modern."
            />

            <div className="mt-14 grid grid-cols-1 md:grid-cols-2 gap-8">
              <div className="rounded-2xl bg-[color:var(--ge-cream)] p-6 md:p-8 border border-[color:var(--ge-navy)]/10">
                <div className="text-[11px] uppercase tracking-[0.32em] font-semibold" style={{ color: "var(--ge-green)" }}>Mission</div>
                <p className="mt-4 text-lg md:text-xl font-medium text-[color:var(--ge-navy)] leading-snug">
                  To create beautifully designed reading glasses that make
                  vision care simpler, more stylish and more sustainable.
                </p>
              </div>
              <div className="rounded-2xl bg-white p-6 md:p-8 border border-[color:var(--ge-navy)]/15">
                <div className="text-[11px] uppercase tracking-[0.32em] font-semibold" style={{ color: "var(--ge-red)" }}>Vision</div>
                <p className="mt-4 text-lg md:text-xl font-medium text-[color:var(--ge-navy)] leading-snug">
                  To redefine the readers category by transforming a functional
                  product into an intuitive, design-led experience.
                </p>
              </div>
            </div>

            <div className="mt-14 flex flex-col md:flex-row md:items-center gap-6 justify-between border-t border-[color:var(--ge-navy)]/15 pt-8">
              <GoodTagline height={80} />
            </div>
          </div>
          <div className="absolute bottom-0 left-0 right-0">
            <BrandStripe height={22} />
          </div>
        </section>

        <NewKindOfReader compact />
        <NZStory />
      </main>
      <Footer />
    </div>
  );
}
